/* eslint-disable no-unused-vars */
import Dexie from "dexie";

const db = new Dexie("esalepos-web-v4");
db.version(7).stores({
  product: "id, *barcodeList,code,name,deptId",
  category: "id,catCode,level",
  config: "id,name",
  customer: "id,name,custId,micrCode,creditCustomer,mobile",
  sync_head:
    "key                                                              ",
  promotion: "id",
  role: "id",
  setting: "id,sKey",
  tax: "id",
  terminal: "id",
  vendor: "id",
  sync_meta: "id",
  sale: "id",
  sale_return: "id",
  info: "key",
  file: "id",
  cost: "id,productId",
  productImport: "id",
  inventoryAdjBulkImport: "id",
  service: "id",
  export_profile_config: "id,name",
  sale_order: "id",
  sale_hold: "id",
  sale_return_hold: "id",
  service_hold: "id",
  sale_order_hold: "id",
  floor: "id",
  fxrate: "id,sourceCurrencyCode",
});

export default db;
